import { render, staticRenderFns } from "./riskIndicators.vue?vue&type=template&id=6dc10298&scoped=true"
import script from "./riskIndicators.vue?vue&type=script&lang=js"
export * from "./riskIndicators.vue?vue&type=script&lang=js"
import style0 from "./riskIndicators.vue?vue&type=style&index=0&id=6dc10298&prod&lang=scss&module=true"
import style1 from "./riskIndicators.vue?vue&type=style&index=1&id=6dc10298&prod&lang=scss&scoped=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "6dc10298",
  null
  
)

export default component.exports